/**
 * Tab-wide "a chat request was just submitted" signal.
 *
 * Module-level so a send from ANY NovaProvider (e.g. an embedded panel)
 * reaches the notification owner, which sustains fast polling until the
 * server reports the stream on the chat row.
 */
let lastLocalSendAtMs: number | null = null;
const listeners = new Set<() => void>();

export function noteLocalSend(nowMs: number): void {
  lastLocalSendAtMs = nowMs;
  for (const listener of listeners) {
    listener();
  }
}

export function getLastLocalSendAtMs(): number | null {
  return lastLocalSendAtMs;
}

export function subscribeLocalSendSignal(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
